const coupon = [
  {
    path: '/coupon-list',
    component: () => import(/* webpackChunkName: "coupon-list" */ '@/pages/coupon/coupon-list.vue'),
    name: 'coupon-list',
    meta: {
      title: '我的优惠券',
      login: false,
      titleBar: false
    }
  },
  {
    path: '/coupon-send/:id',
    component: () => import(/* webpackChunkName: "coupon-send" */ '@/pages/coupon/double-eleven/coupon-send.vue'),
    name: 'coupon-send',
    meta: {
      title: '赠送优惠券',
      login: true,
      titleBar: {
        title: '优惠券',
        hasMenu: true
      }
    }
  },
  {
    path: '/coupon-receive-status',
    component: () => import(/* webpackChunkName: "coupon-receive-status" */ '@/pages/coupon/double-eleven/coupon-receive-status.vue'),
    name: 'coupon-receive-status',
    meta: {
      title: '领取优惠券',
      titleBar: {
        title: '优惠券',
        hasMenu: true
      }
    }
  },
  {
    path: '/coupon-receive-result',
    component: () => import(/* webpackChunkName: "coupon-receive-result" */ '@/pages/coupon/coupon-receive-result.vue'),
    name: 'coupon-receive-result',
    meta: {
      title: '领取优惠券成功',
      login: true,
      titleBar: {
        title: '优惠券',
        hasMenu: true
      }
    }
  }
]

export default coupon
